import { call, put, takeEvery, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as congNoConstant from './constants'
import * as congNoAction from './actions'
import { transfersFromCached } from '../../lib/common'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function khoXuatRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONG_NO_KHOXUAT_API,
    formData
  )

  return handleRequest(request);
}
function* congNoKhoXuatRequestFlow({payload}) {
  try {
    // grab the client from our action
    const {data} = yield call(khoXuatRequestApi, payload)
    // dispatch the action with our widgets!
    yield put(congNoAction.congNoKhoXuatSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(congNoAction.congNoKhoXuatError(error))
  }
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONG_NO_LIST_API,
    formData
  )

  return handleRequest(request);
}


function* congNoListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoListSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoListError(error))
  }
}
function exportXlsRequestApi(formData) {
  let url = congNoConstant.CONG_NO_EXPORT_XLS_API + "?s=" + formData.storeId + "&k=" + formData.khoIds + "&nv=" + formData.maNhanVien
    + "&lcn=" + formData.loai + "&tn=" + formData.fromDate + "&dn=" + formData.toDate
    + "&kw=" + formData.keyword + "&p=" + formData.page + "&pp=" + formData.per_page;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(congNoAction.reportExportXlsSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.reportExportXlsError(error))
  }
}
function congNoKHRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONG_NO_KH_LIST_API,
    formData
  )

  return handleRequest(request);
}


function* congNoKHListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(congNoKHRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoKHListSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoKHListError(error))
  }
}
function congNoKHXlsRequestApi(formData) {
  let url = congNoConstant.CONG_NO_KH_EXPORT_XLS_API + "?s=" + formData.storeId + "&mkh=" + formData.maKH
    + "&tn=" + formData.fromDate + "&dn=" + formData.toDate
    + "&p=" + formData.page + "&pp=" + formData.per_page;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* congNoKHExportXlsRequestFlow(action) {
  const { formData } = action
  try {
    // grab the client from our action
    const results = yield call(congNoKHXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(congNoAction.congNoKHExportXlsSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoKHExportXlsError(error))
  }
}

function congNoHDRequestApi(formData) {
  const request = axiosApi().post(
    congNoConstant.CONG_NO_HD_LIST_API,
    formData
  )

  return handleRequest(request);
}


function* congNoHDListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(congNoHDRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(congNoAction.congNoHDListSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoHDListError(error))
  }
}
function congNoHDXlsRequestApi(formData) {
  let url = congNoConstant.CONG_NO_HD_EXPORT_XLS_API + "?s=" + formData.storeId 
    + "&hd=" + formData.maHD;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* congNoHDExportXlsRequestFlow(action) {
  const { formData } = action
  try {
    // grab the client from our action
    const results = yield call(congNoHDXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(congNoAction.congNoHDExportXlsSuccess(results.data))

  } catch (error) {
    yield put(congNoAction.congNoHDExportXlsError(error))
  }
}
function* congNoWatcher() {
  yield [
    takeLatest(congNoConstant.CONG_NO_KHOXUAT_REQUESTING, congNoKhoXuatRequestFlow),
    takeEvery(congNoConstant.CONG_NO_LIST_REQUESTING, congNoListRequestFlow),
    takeEvery(congNoConstant.CONG_NO_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeEvery(congNoConstant.CONG_NO_KH_LIST_REQUESTING, congNoKHListRequestFlow),
    takeEvery(congNoConstant.CONG_NO_KH_EXPORT_XLS_REQUESTING, congNoKHExportXlsRequestFlow),
    takeEvery(congNoConstant.CONG_NO_HD_LIST_REQUESTING, congNoHDListRequestFlow),
    takeEvery(congNoConstant.CONG_NO_HD_EXPORT_XLS_REQUESTING, congNoHDExportXlsRequestFlow),
  ]
}

export default congNoWatcher



// WEBPACK FOOTER //
// ./src/views/CongNo/sagas.js